import type { MapExportOrientation, MapExportPaperSize } from "./printLayout";

/**
 * 現在のデバイスがモバイル（スマートフォン・タブレット）かどうかを判定する。
 * iPadのデスクトップ表示対応（タッチパネル判定）を含む。
 */
export const checkIsMobile = (): boolean => {
  return (
    typeof navigator !== "undefined" &&
    (navigator.userAgent.includes("Mobi") ||
      navigator.userAgent.includes("Mobile") ||
      navigator.userAgent.includes("Android") ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1))
  );
};

/**
 * 用紙サイズと解像度の組み合わせがブラウザの限界値（画素数）を超えているかチェックする。
 * 携帯端末は16.78Mpx (4096*4096相当) を上限とし、PC環境は80Mpxを上限とする。
 */
export const checkCanvasSizeExceeded = (
  paperSize: MapExportPaperSize,
  orientation: MapExportOrientation,
  dpi: number
): boolean => {
  const PAPER_SIZES_MM: Record<MapExportPaperSize, [number, number]> = {
    a4: [210, 297],
    a3: [297, 420],
  };
  const [shortSide, longSide] = PAPER_SIZES_MM[paperSize];
  const widthMm = orientation === "portrait" ? shortSide : longSide;
  const heightMm = orientation === "portrait" ? longSide : shortSide;

  const isMobile = checkIsMobile();

  // 携帯端末は16.78Mpx、デスクトップPCは80Mpxを上限とする
  const MAX_PIXELS = isMobile ? 16_777_216 : 80_000_000;

  const estimatedPixels = widthMm * (dpi / 25.4) * (heightMm * (dpi / 25.4));

  return estimatedPixels > MAX_PIXELS;
};
